<template>
  <div class="form-group">
    <br />
    <div class="form-buttons">
      <!--   <button class="btn btn-xs btn-success pull-right" @click="$emit('save')">
                    Ok
                  </button>-->

      <!--   <button class="bttn pull-right" @click="$emit('update')">UPDATE</button>-->
      <button class=" newPlaceForBttn" @click="$emit('close')">CLOSE</button>

      <!--      <button
                    class="btn btn-xs btn-default pull-right"
                    @click="$emit('cancel')"
                  >
                    Cancel
                  </button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "form-buttons"
};
</script>

<style lang="scss" scoped>
/*.bttn {*/
/*  font-family: Montserrat !important;*/
/*  width: fit-content;*/
/*  margin-top: 0.5rem;*/
/*  margin-left: 1rem;*/
/*  background: #efefef;*/
/*  color: black;*/
/*  border: 0;*/
/*  border-radius: inherit;*/
/*  padding: 5px;*/
/*  font-size: 10px;*/
/*  !*font-family: inherit;*!*/
/*  cursor: pointer;*/
/*}*/
.newPlaceForBttn {
  font-family: Montserrat !important;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 0.5rem;
  position: absolute;
  top: 7px;
  left: 27px;
  border-radius: 5px;
  background: #efefef;
  color: black;
  border: 0;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
}
</style>
